module.exports = __webpack_public_path__ + "static/media/blue.33a04214.png";